import React from 'react';
import styled from 'styled-components';

import { DebugDiv } from '../../../../components/Debug';
import { HermesysColors } from '../../Colors';
import { MenuButtonSize, PanelWidth } from '../../Dimentions';
import { MenuItem } from './Console';
import ListButton from './MenuButtonTypes/ListButton';
import NavigationButton from './MenuButtonTypes/NavigationButton';
import ToggleButton from './MenuButtonTypes/ToggleButton';

export const MenuButtonContainer = styled.button<any>`
  width: ${MenuButtonSize.width}px;
  height: ${MenuButtonSize.height}px;
  background: ${HermesysColors.ButtonBackgroundGray};
  border: ridge 1px black;
  text-align: center;
  position: relative;
  word-break: break-word;
  font-size: 14px;
  transition: box-shadow 0.5s;

  ${({ clicked }) => {
    if (clicked) {
      return `
      // box-shadow: inset 4px -4px 2px gray;
      border: inset 4px black;
      border-color: rgb(0, 0, 0) rgb(170, 170, 170) rgb(170, 170, 170) rgb(0, 0, 0);
      `;
    }
  }}
`;

export const StyledToggleButtonContainer = styled(MenuButtonContainer as any)`
  display: grid;
  align-items: center;
`;

export const ButtonTypes = {
  NavigationButtonPrev: 'NavigationButtonPrev',
  ListButton: 'ListButton',
  Button: 'Button',
  ToggleButton: 'ToggleButton',
  NavigationButtonNext: 'NavigationButtonNext',
};

export const formatLabel = (label: string | undefined) =>
  label?.split(' ').map((line) => <div>{line}</div>);

export interface MenuButtonProps {
  item: MenuItem;
  buttonIdentifier: string | number;
}

const MenuButton = ({ item, buttonIdentifier }: MenuButtonProps) => {
  switch (item.type) {
    case ButtonTypes.ListButton:
      return <ListButton item={item} buttonIdentifier={buttonIdentifier} />;
    case ButtonTypes.NavigationButtonNext:
    case ButtonTypes.NavigationButtonPrev:
      return (
        <NavigationButton item={item} buttonIdentifier={buttonIdentifier} />
      );
    case ButtonTypes.ToggleButton:
      return (
        <ToggleButton
          item={item}
          buttonIdentifier={buttonIdentifier}
        ></ToggleButton>
      );
    default:
      return (
        <MenuButtonContainer disabled={item?.attributes?.disabled}>
          <DebugDiv>{buttonIdentifier}</DebugDiv>
          {formatLabel(item.label)}
        </MenuButtonContainer>
      );
  }
};

export default MenuButton;
